export default "__VITE_ASSET__Cb5g_9m8__"